import { useSelector } from 'react-redux';
import styles from 'styles/modules/CreditsDisplay.module.scss';
import { authSelector } from 'store/auth';
import { hasUnlimitedResponses } from 'utils/subscriptionAccess';

const CreditsDisplay = () => {
    const { isAuthenticated } = useSelector(authSelector);
    const companyData = useSelector(({ company }) => company.data);
    const {
        plan,
        isAdmin: viewedUserIsAdmin,
        isContributingEditor: viewedUserIsContributingEditor,
        responseCredit: viewedUserResponseCredit,
    } = companyData || {};

    // Free has no count to show: unlimited until the first counted coverage, then none, and the
    // profile page only gets the plan type, not the coverage.
    if (
        !isAuthenticated ||
        plan?.type === 'free' ||
        plan?.type === 'platinum' ||
        viewedUserIsContributingEditor
    ) {
        return null;
    }

    const hasUnlimited = hasUnlimitedResponses(plan?.type) || viewedUserIsAdmin;
    const totalResponses =
        (plan?.responsesLeft || 0) + (viewedUserResponseCredit || 0);

    return (
        <div className={styles.creditsContainer}>
            <div className={styles.creditsDisplay}>
                <span className={styles.creditsLabel}>
                    Available News Alert responses:
                </span>
                <span
                    className={`${styles.creditsCount} ${
                        !hasUnlimited &&
                        totalResponses > 0 &&
                        totalResponses <= 2
                            ? styles.lowCredits
                            : ''
                    }`}
                >
                    {hasUnlimited ? 'unlimited' : totalResponses}
                </span>
            </div>
        </div>
    );
};

export default CreditsDisplay;
